import React, { useState } from "react";
import Image from "lib/Image";
import "./index.scss";
import { Card, Row } from "react-bootstrap";
import Compare from "components/Compare/Compare";
import { BASE_URL } from "constants/routes";
import { useSelector } from "react-redux";
import ProfileIcon from "assets/images/profileicon.png";
import { Col,Container } from 'react-bootstrap';


const UserDetail = (props) => {
  const { input_fields, formFields, selectedData, name, isMobile } = props;
  const [showCompareDocumentsModal, setShowCompareDocumentsModal] =
    useState(false);

  let imageSrc = "";
  if (formFields?.user_image) {
    const imgObject =
      (eval(formFields?.user_image) && eval(formFields?.user_image)) || {};
    if (imgObject?.encrypted_filename && selectedData?._id) {
      imageSrc = `${BASE_URL}/workflow/viewUploadedDocument/${selectedData?._id}/${formFields?.user_image_name}/${imgObject?.encrypted_filename}`;
    }
  }

  const applicationStatus = useSelector(
    (state) => state?.dashboardDetailReducer?.userSubworkFlowInfo?.status
  );
  const compareDoc = useSelector((state) => state?.dashboardDetailReducer?.dashboardDetailConfiguration?.configurationInfo?.compare_doc);
  const emailIcon = `<svg data-name="Group 37165"height=12 id=Group_37165 class="text-theme" fill="currentColor" viewBox="0 0 16 12"width=16 xmlns=http://www.w3.org/2000/svg><path d=M14.4,12H1.6A1.554,1.554,0,0,1,0,10.5l.009-9A1.549,1.549,0,0,1,1.6,0H14.4A1.554,1.554,0,0,1,16,1.5v9A1.554,1.554,0,0,1,14.4,12ZM1.6,1.5V3L8,6.75,14.4,3V1.5L8,5.25Z data-name="Fill 67" id=Fill_67 /></svg>`;
  const phoneIcon = `<svg data-name="Group 37167"height=16.506 id=Group_37167 class="text-theme" fill="currentColor" viewBox="0 0 16.506 16.506"width=16.506 xmlns=http://www.w3.org/2000/svg><path d=M3.32,7.143a13.891,13.891,0,0,0,6.043,6.043l2.017-2.017a.912.912,0,0,1,.935-.22,10.46,10.46,0,0,0,3.274.523.92.92,0,0,1,.917.917v3.2a.92.92,0,0,1-.917.917A15.588,15.588,0,0,1,0,.917.92.92,0,0,1,.917,0H4.126a.92.92,0,0,1,.917.917,10.417,10.417,0,0,0,.523,3.274.92.92,0,0,1-.229.935L3.32,7.143 data-name="Fill 137" id=Fill_137 /></svg>`;
  const locationIcon = `<svg data-name="Group 37169"height=18 id=Group_37169  class="text-theme" fill="currentColor" viewBox="0 0 12 18"width=12 xmlns=http://www.w3.org/2000/svg><path d=M6,18H6c-.06-.07-6-7.056-6-11.7A6.162,6.162,0,0,1,6,0a6.163,6.163,0,0,1,6,6.3C12,10.942,6.06,17.929,6,18ZM6,4.05A2.2,2.2,0,0,0,3.857,6.3,2.2,2.2,0,0,0,6,8.55,2.2,2.2,0,0,0,8.143,6.3,2.2,2.2,0,0,0,6,4.05Z data-name="Fill 153" id=Fill_153 /></svg>`;
  const imageUpload = `<svg id="graphic_upload_document" data-name="graphic / upload document" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 25.384 30.692"><path id="Path" d="M18.3,0H.621A.622.622,0,0,0,0,.622v23.91a.622.622,0,0,0,.621.622H18.3a.622.622,0,0,0,.621-.622V.622A.622.622,0,0,0,18.3,0Z" fill="#d3dbeb"/>
  <path id="Path-2" data-name="Path" d="M.429,0A.435.435,0,0,0,0,.439V23.1a.435.435,0,0,0,.429.439h16.68a.435.435,0,0,0,.429-.439V.439A.435.435,0,0,0,17.109,0Z" transform="translate(0.692 0.692)" fill="#fff"/>
  <path id="Path-3" data-name="Path" d="M.287,0A.3.3,0,0,0,0,.316V3.376a.3.3,0,0,0,.287.316H15.174a.3.3,0,0,0,.287-.316V.316A.3.3,0,0,0,15.174,0Z" transform="translate(1.846 1.846)" fill="#e9edf5"/>
  <path id="Path-4" data-name="Path" d="M.287,0A.294.294,0,0,0,0,.3V7.085a.294.294,0,0,0,.287.3H15.174a.294.294,0,0,0,.287-.3V.3a.294.294,0,0,0-.287-.3Z" transform="translate(1.846 7.154)" fill="#e9edf5"/>
  <rect id="Rectangle" width="11.769" height="0.692" transform="translate(3.692 2.538)" fill="#fff"/>
  <rect id="Rectangle-2" data-name="Rectangle" width="11.769" height="0.231" transform="translate(3.692 3.877)" fill="#fff"/>
  <rect id="Rectangle-3" data-name="Rectangle" width="11.769" height="0.231" transform="translate(3.692 4.615)" fill="#fff"/>
  <path id="Path-5" data-name="Path" d="M7.809,5.769h5.4a.174.174,0,0,0,.161-.11.181.181,0,0,0-.038-.194L9.877,1.928a.171.171,0,0,0-.246,0l-.86.88a.359.359,0,0,1-.516,0L5.563.052a.171.171,0,0,0-.246,0L.051,5.441a.181.181,0,0,0-.038.194.174.174,0,0,0,.161.11H7.816Z" transform="translate(2.769 8.769)" fill="#fff"/>
  <circle id="Oval" cx="0.692" cy="0.692" r="0.692" transform="translate(3.461 8.077)" fill="#fff"/>
  <path id="Path-6" data-name="Path" d="M.287,0A.294.294,0,0,0,0,.3V7.085a.294.294,0,0,0,.287.3H15.174a.294.294,0,0,0,.287-.3V.3a.294.294,0,0,0-.287-.3Z" transform="translate(1.846 15.923)" fill="#e9edf5"/>
  <path id="Path-7" data-name="Path" d="M7.809,5.769h5.4a.174.174,0,0,0,.161-.11.181.181,0,0,0-.038-.194L9.877,1.928a.171.171,0,0,0-.246,0l-.86.88a.359.359,0,0,1-.516,0L5.563.052a.171.171,0,0,0-.246,0L.051,5.441a.181.181,0,0,0-.038.194.174.174,0,0,0,.161.11H7.816Z" transform="translate(2.769 17.538)" fill="#fff"/>
  <circle id="Oval-2" data-name="Oval" cx="0.692" cy="0.692" r="0.692" transform="translate(3.461 16.846)" fill="#fff"/>
  <path id="Path-8" data-name="Path" d="M.439,0A.438.438,0,0,0,0,.437V24.716a.438.438,0,0,0,.439.437H18.484a.438.438,0,0,0,.439-.437V.437A.438.438,0,0,0,18.484,0Z" transform="translate(6.461 5.538)" fill="#d3dbeb"/>
  <path id="Path-9" data-name="Path" d="M.429,0A.437.437,0,0,0,0,.443V23.326a.437.437,0,0,0,.429.443h16.68a.437.437,0,0,0,.429-.443V.443A.437.437,0,0,0,17.109,0Z" transform="translate(7.154 6.231)" fill="#fff"/>
  <path id="Path-10" data-name="Path" d="M.193,0A.185.185,0,0,0,0,.175v.8a.185.185,0,0,0,.193.175H11.576a.185.185,0,0,0,.193-.175v-.8A.185.185,0,0,0,11.576,0Z" transform="translate(9.692 9.461)" fill="currentColor"/>
  <path id="Path-11" data-name="Path" d="M.048,0A.049.049,0,0,0,0,.05V.411a.049.049,0,0,0,.048.05H11.491a.049.049,0,0,0,.048-.05V.05A.049.049,0,0,0,11.491,0Z" transform="translate(9.923 12.461)" fill="#eaf0fb"/>
  <path id="Path-12" data-name="Path" d="M.048,0A.049.049,0,0,0,0,.05V.411a.049.049,0,0,0,.048.05H11.491a.049.049,0,0,0,.048-.05V.05A.049.049,0,0,0,11.491,0Z" transform="translate(9.923 13.615)" fill="#eaf0fb"/>
  <path id="Path-13" data-name="Path" d="M.048,0A.049.049,0,0,0,0,.05V.411a.049.049,0,0,0,.048.05H11.491a.049.049,0,0,0,.048-.05V.05A.049.049,0,0,0,11.491,0Z" transform="translate(9.923 14.769)" fill="#eaf0fb"/>
  <path id="Path-14" data-name="Path" d="M.048,0A.049.049,0,0,0,0,.05V.411a.049.049,0,0,0,.048.05H11.491a.049.049,0,0,0,.048-.05V.05A.049.049,0,0,0,11.491,0Z" transform="translate(9.923 16.846)" fill="#eaf0fb"/>
  <path id="Path-15" data-name="Path" d="M.048,0A.049.049,0,0,0,0,.05V.411a.049.049,0,0,0,.048.05H11.491a.049.049,0,0,0,.048-.05V.05A.049.049,0,0,0,11.491,0Z" transform="translate(9.923 18)" fill="#eaf0fb"/>
  <path id="Path-16" data-name="Path" d="M.048,0A.049.049,0,0,0,0,.05V.411a.049.049,0,0,0,.048.05H11.491a.049.049,0,0,0,.048-.05V.05A.049.049,0,0,0,11.491,0Z" transform="translate(9.923 19.153)" fill="#eaf0fb"/>
  <path id="Path-17" data-name="Path" d="M.048,0A.049.049,0,0,0,0,.05V.411a.049.049,0,0,0,.048.05H11.491a.049.049,0,0,0,.048-.05V.05A.049.049,0,0,0,11.491,0Z" transform="translate(9.923 20.307)" fill="#eaf0fb"/>
  <path id="Path-18" data-name="Path" d="M.048,0A.049.049,0,0,0,0,.05V.411a.049.049,0,0,0,.048.05H11.491a.049.049,0,0,0,.048-.05V.05A.049.049,0,0,0,11.491,0Z" transform="translate(9.923 21.461)" fill="#eaf0fb"/>
  <path id="Path-19" data-name="Path" d="M.048,0A.049.049,0,0,0,0,.05V.411a.049.049,0,0,0,.048.05H11.491a.049.049,0,0,0,.048-.05V.05A.049.049,0,0,0,11.491,0Z" transform="translate(9.923 22.615)" fill="#eaf0fb"/>
  <path id="Path-20" data-name="Path" d="M.048,0A.049.049,0,0,0,0,.05V.411a.049.049,0,0,0,.048.05H11.491a.049.049,0,0,0,.048-.05V.05A.049.049,0,0,0,11.491,0Z" transform="translate(9.923 23.769)" fill="#eaf0fb"/>
  <path id="Path-21" data-name="Path" d="M.048,0A.049.049,0,0,0,0,.05V.411a.049.049,0,0,0,.048.05H11.491a.049.049,0,0,0,.048-.05V.05A.049.049,0,0,0,11.491,0Z" transform="translate(9.923 24.923)" fill="#eaf0fb"/>
  <path id="Path-22" data-name="Path" d="M.048,0A.049.049,0,0,0,0,.05V.411a.049.049,0,0,0,.048.05H11.491a.049.049,0,0,0,.048-.05V.05A.049.049,0,0,0,11.491,0Z" transform="translate(9.923 26.076)" fill="#eaf0fb"/>
</svg>`;
const showPassword = `
<svg enable-background="new 0 0 32 32" class="text-theme" stroke="currentColor" id="Editable-line" width="25" height="24" version="1.1" viewBox="0 0 32 32" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <path d="  M16,7C9.934,7,4.798,10.776,3,16c1.798,5.224,6.934,9,13,9s11.202-3.776,13-9C27.202,10.776,22.066,7,16,7z" fill="none" id="XMLID_13_"  stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2" />
  <circle cx="16" cy="16" fill="none" id="XMLID_14_" r="3.5"  stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2" />
  <line fill="none" id="XMLID_15_"  stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2" x1="3" x2="30" y1="5" y2="29" />
</svg>
`
const hidePassword = `<svg id="look" class="text-theme" fill="currentColor" xmlns="http://www.w3.org/2000/svg"  width="20." height="15" viewBox="0 0 16.204 10.604">
<path id="Path_4093" data-name="Path 4093" d="M16.167,42.5q-.008-.021-.018-.042A8.928,8.928,0,0,0,.064,42.439a.562.562,0,0,0-.008.5,8.928,8.928,0,0,0,16.093,0A.563.563,0,0,0,16.167,42.5ZM8.1,46.878A7.852,7.852,0,0,1,1.191,42.7a7.805,7.805,0,0,1,13.823,0A7.853,7.853,0,0,1,8.1,46.878Z" transform="translate(-0.001 -37.397)"/>
<path id="Path_4094" data-name="Path 4094" d="M77.757,75.291a2.465,2.465,0,1,0,2.465,2.465A2.467,2.467,0,0,0,77.757,75.291Zm0,3.806A1.341,1.341,0,1,1,79.1,77.756,1.343,1.343,0,0,1,77.757,79.1Z" transform="translate(-69.655 -72.454)"/>
</svg>`;
  const ChooseImage = (fieldName) => {
    if (fieldName === "email") {
      return emailIcon;
    } else if (fieldName === "mobile_number") {
      return phoneIcon;
    } else if (fieldName === "residence_country") {
      return locationIcon;
    } else {
      return '';
    }
  };
  // copied from ViewCard.js
  const [maskType,setMaskType] = useState({})
  const togglePassword =(name)=>{
    if(maskType[name] === true)
    {
      let mask_type = {...maskType}
      mask_type[name] = false
      setMaskType(mask_type)
     return;
    }
    let mask_type = {...maskType}
    mask_type[name] = true
    setMaskType(mask_type)
  }
  const  maskedData = (data) =>{
    let masked_data =''
    for (const ch of data) {
      masked_data +='*'
    }
    return masked_data
  }


  return (
      <>
              <Container fluid>
              <Row className="py-3 gy-3 gy-md-0 justify-content-center" id={name}>
                { eval(formFields?.compare_doc_required) ? 
                  <Col xs={12} className="d-block d-md-none">
                      <p
                          className="m-0 cursor-pointer fw-bold text-theme text-end"
                          onClick={() => setShowCompareDocumentsModal(true)}
                      >
                          {"Compare Document"}
                      </p>
                  </Col>
 :" "}
                  <Col xs={6} md={4} lg={3} xxl={2}>
                      <div className="border rounded br-top-left-15px br-top-right-15px d-flex flex-column alig-items-center">
                          <Image
                              className="img-fluid max-h-150px br-top-left-15px br-top-right-15px "
                              imageSrc={imageSrc ? imageSrc : ProfileIcon}
                              altText="profile image not found"
                          />
                          <div className="w-100 bg-light-theme text-center p-2">
                              <p className="m-0 fw-bold text-theme">
                                  {applicationStatus || 'Under approval'}
                              </p>
                          </div>
                      </div>
                  </Col>
                  <Col xs={12} md={8} lg={9} xxl={10}>
                      <Row>
                          <Col xs={12} md={12} lg={12}>
                              <Row className="align-items-center justify-content-between mb-2 mb-md-3">
                                  <Col xs={12} md={6} lg={6}>
                                      <p className="m-0 fw-bold text-primary-grey h5 break-work-when-exceeds">
                                          {selectedData?.['full_name']}
                                      </p>
                                  </Col>
                                  { eval(formFields?.compare_doc_required) ? 
                                  <Col
                                      xs={12}
                                      md={6}
                                      lg={6}
                                      className="d-none d-md-block"
                                  >
                                      <div className="text-start text-md-end">
                                          <p
                                              className="m-0 fw-semibold cursor-pointer text-theme fs-15px"
                                              onClick={() =>
                                                  setShowCompareDocumentsModal(
                                                      true
                                                  )
                                              }
                                          >
                                              {"Compare Document"}
                                          </p>
                                      </div>
                                  </Col>
                                    :""}
                              </Row>
                          </Col>
                          <Col xs={12} md={12} lg={12}>
                              <Row className="mx-md-0 bg-theme-grey-1 rounded-1">
                                  {input_fields?.map((item, i) => {
                                      const {
                                          size,
                                          //  label,
                                          masking_type,
                                          name
                                      } = item;
                                      return (
                                         <> 
                                         { (eval(item?.show == false)) ? '' 
                                          : <div className={`${size}`} key={i}>
                                          <div className="py-3 d-flex align-items-center">
                                              <span className="me-2 mt-0" dangerouslySetInnerHTML={{ __html: ChooseImage(name) }}>
                                              </span>
                                              <p className="m-0 text-muted pt-2 break-work-when-exceeds">
                                                  {(maskType[name] === true || !maskType.hasOwnProperty(name)) && masking_type ? maskedData(selectedData?.[name]) : selectedData?.[name]}

                                              </p>
                                              {
                                                  masking_type ? (
                                                      <span className="d-flex align-items-center justify-content-center cursor-pointer ms-2" dangerouslySetInnerHTML={{
                                                          __html: (maskType[name] === true || !maskType.hasOwnProperty(name)) ? hidePassword : showPassword
                                                      }} onClick={(e) => togglePassword(name)}></span>
                                                  ) : null
                                              }
                                          </div>
                                      </div>
                                  }
                                          </>
                                      );
                                  })}
                              </Row>
                          </Col>
                      </Row>
                  </Col>
              </Row>
              </Container>
              {showCompareDocumentsModal && (
                  <Compare
                      showCompareDocumentsModal={showCompareDocumentsModal}
                      setShowCompareDocumentsModal={
                          setShowCompareDocumentsModal
                      }
                  />
              )}
      </>
  );
};

export default UserDetail;
